import { useResponsive } from 'ahooks';
import { QueryParamProvider } from 'providers/storefront/QueryProvider';
import { useEffect, useState } from 'react';
import StickyBox from 'react-sticky-box';
import { PcConfiguratorProvider } from 'utils/PcConfiguratorContext';
import PcModelBreadCrumbs from './PcModelBreadCrumbs';
import PcModelIntro from './PcModelIntro';
import PcModelOptions from './PcModelOptions';
import PcModelOverview from './PcModelOverview';
import PcModelSteps from './PcModelSteps';
import PcModelStepsNext from './PcModelStepsNext';
import styles, { global } from './styles';
import { useRouter } from 'next/router';
import ReactPlayer from 'react-player';
import Modal from 'react-modal';
import useScreenWidth from 'utils/useScreenWidth';
import PcModelSaleHighlights from './PcModeSaleHighlights';

const PcModel = ({ pcModel, prices, stocks, pcConfigDoc, modelTheme }) => {
  const router = useRouter();
  const responsive = useResponsive();
  const productType = pcModel?.buildType?.build_type_name;
  const [navbar, setNavbar] = useState(false);
  const [navbarTablet, setNavbarTablet] = useState(false);
  const [navbarMobile, setNavbarMobile] = useState(false);
  const [stepUltraLabs, setStepUltraLabs] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [clickMore, setClickMore] = useState(false);

  const sale_highlights = {
    banner: pcConfigDoc?.data?.sale_highlights_banner.url,
    highlights: pcConfigDoc?.data?.sale_highlights,
  };

  useEffect(() => {
    router.pathname == '/pc-models/[uid]' &&
      document &&
      document.body.classList.add('customize-page-product');
  });

  const handleNavbar = () => {
    if (window.scrollY >= 473) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  const handleNavbarMobile = () => {
    if (window.scrollY >= 553) {
      setNavbarMobile(true);
    } else {
      setNavbarMobile(false);
    }
  };
  const handleNavbarTablet = () => {
    if (window.scrollY >= 533) {
      setNavbarTablet(true);
    } else {
      setNavbarTablet(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleNavbar);

    return () => window.removeEventListener('scroll', handleNavbar);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleNavbarMobile);

    return () => window.removeEventListener('scroll', handleNavbarMobile);
  }, []);
  useEffect(() => {
    window.addEventListener('scroll', handleNavbarTablet);

    return () => window.removeEventListener('scroll', handleNavbarTablet);
  }, []);

  const widthSize = useScreenWidth();
  const customStyles = {
    content: {
      top: widthSize <= 500 ? '50%' : '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      padding: widthSize <= 500 ? '15px 10px' : '15px 20px',
      width: widthSize <= 500 ? '100%' : '80%',
      height: widthSize <= 500 ? '55%' : '90%',
      background: '#3c3c3c',
      border: '1px solid #3c3c3c',
      overflow: 'hidden',
    },
  };

  const openModal = () => {
    setPlaying(true);
    document.body.style.overflow = 'hidden'; // Prevent scrolling
  };

  const closeModal = () => {
    setPlaying(false);
    document.body.style.overflow = 'auto'; // Enable scrolling
  };

  const [activeTab, setActiveTab] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleTabClick = (tabIndex) => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setTimeout(() => {
        setActiveTab(tabIndex);
        setIsTransitioning(false);
      }, 500); // Transition duration + a small delay
    }
  };

  let video_thumbnail;
  let videoId;
  if (stepUltraLabs && modelTheme.ultralabs_video != '') {
    console.log({ url: modelTheme.ultralabs_video.thumbnail.url });
    if (modelTheme.ultralabs_video.thumbnail.url == undefined) {
      console.log({ link: modelTheme.ultralabs_video.video_link });
      videoId = modelTheme.ultralabs_video.video_link
        .match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/)
        ?.pop();
      console.log({ videoId });
      if (videoId?.length == 11) {
        video_thumbnail = `https://img.youtube.com/vi/${videoId}/0.jpg`;
      }
    } else {
      video_thumbnail = modelTheme.ultralabs_video.thumbnail.url;
    }
  }

  return (
    <>
      <QueryParamProvider>
        <PcConfiguratorProvider
          pcModel={pcModel}
          prices={prices}
          stocks={stocks}
          pcConfigDoc={pcConfigDoc}
        >
          {/* <div className="pc-model-wrapper wrapper">
            <PcModelBreadCrumbs />
          </div> */}

          <div className='pc-model-wrapper '>
            <PcModelIntro modelTheme={modelTheme} />
          </div>

          <div id='pc-configurator' className='pc-configurator'>
            <div className='pc-model-wrapper'>
              <PcModelSteps
                navbar={navbar}
                navbarTablet={navbarTablet}
                navbarMobile={navbarMobile}
                handleTabClick={handleTabClick}
              />
            </div>

            <div
              className={`fade pc-model-wrapper wrapper ${
                isTransitioning ? '' : 'show'
              }`}
            >
              <div
                className={`pc-model-config-container ${
                  navbar ? 'sticky-container-desktop' : ''
                } ${navbarTablet ? 'sticky-container-tablet' : ''} ${
                  navbarMobile ? 'sticky-container-mobile' : ''
                }`}
                style={stepUltraLabs ? { marginTop: '50px' } : {}}
              >
                {stepUltraLabs && modelTheme.ultralabs_video != '' && (
                  <>
                    <div className='ultralabs-video-dekstop'>
                      <div className='video-container'>
                        <div className='video-section' onClick={openModal}>
                          <img
                            draggable='false'
                            src={video_thumbnail}
                            width={'100%'}
                            height={'134%'}
                            alt='thumbnail'
                          />
                          <img
                            draggable='false'
                            src='https://cdn.shopify.com/s/files/1/0637/0407/2436/files/circled_play_black.png?v=1714057965'
                            className='circled-play-white'
                            style={{ position: 'absolute' }}
                            alt='icon-play'
                          />
                        </div>
                        <div className='description-section'>
                          <p className='header'>
                            {modelTheme.ultralabs_video.header}
                          </p>
                          <p className='description'>
                            {modelTheme.ultralabs_video.description1}
                          </p>
                          <div className='watch-video-container'>
                            <div className='watch-btn-con'>
                              <img
                                draggable='false'
                                src='https://cdn.shopify.com/s/files/1/0637/0407/2436/files/circled_play_black.png?v=1714057965'
                                className='circled-play'
                                alt='icon-play'
                              />
                              <span className='watch-video' onClick={openModal}>
                                WATCH VIDEO
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='ultralabs-video-mobile'>
                      <div className='video-section-mobile'>
                        <div
                          className='video-container-mobile'
                          onClick={() => setClickMore(!clickMore)}
                        >
                          <img
                            draggable='false'
                            src={video_thumbnail}
                            width={'100%'}
                            height={'134%'}
                            alt='thumbnail'
                          />
                          <img
                            draggable='false'
                            src='https://cdn.shopify.com/s/files/1/0637/0407/2436/files/circled_play_black.png?v=1714057965'
                            className='circled-play-mobile'
                            style={{ position: 'absolute' }}
                            alt='icon-play'
                          />
                        </div>

                        <div className='description-container-mobile'>
                          <p className='header-mobile'>
                            {modelTheme.ultralabs_video.header}
                          </p>
                          <a
                            className='click-more'
                            onClick={() => setClickMore(!clickMore)}
                          >
                            Click to learn more
                          </a>
                        </div>

                        <div
                          className='toggle-icon-con'
                          onClick={() => setClickMore(!clickMore)}
                        >
                          <img
                            draggable='false'
                            src={
                              !clickMore
                                ? 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/ChevronDown.svg?v=1714034100'
                                : 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/ChevronUp.svg?v=1714034075'
                            }
                            className='toggle-icon'
                          />
                        </div>
                      </div>

                      <div
                        className='description-section-mobile'
                        style={
                          clickMore ? { display: 'flex' } : { display: 'none' }
                        }
                      >
                        <p className='description-mobile'>
                          {modelTheme.ultralabs_video.description1}
                        </p>

                        <div className='watch-video-container'>
                          <div className='watch-btn-con'>
                            <img
                              draggable='false'
                              src='https://cdn.shopify.com/s/files/1/0637/0407/2436/files/circled_play_black.png?v=1714057965'
                              className='circled-play'
                            />
                            <span className='watch-video' onClick={openModal}>
                              WATCH VIDEO
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <Modal
                        style={customStyles}
                        isOpen={playing}
                        contentLabel='Minimal Modal Example'
                        onRequestClose={closeModal}
                      >
                        <button
                          className='modal-btn-close'
                          onClick={closeModal}
                        >
                          {widthSize <= 500 ? 'x' : 'Close'}
                        </button>
                        <p className='modal-header'>
                          {modelTheme.ultralabs_video.header}
                        </p>
                        <div className='ultralabs-video-container'>
                          <ReactPlayer
                            className='react-player'
                            url={modelTheme.ultralabs_video.video_link}
                            playing={playing}
                            width='100%'
                            height='100%'
                            controls
                          />
                        </div>
                      </Modal>
                    </div>
                  </>
                )}
                <div
                  className='pc-model-config-options'
                  style={
                    !modelTheme?.show_graph_block
                      ? {
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }
                      : null
                  }
                >
                  <PcModelOptions
                    modelTheme={modelTheme}
                    setStepUltraLabs={setStepUltraLabs}
                    playing={playing}
                  />

                  {modelTheme?.show_graph_block && (
                    <StickyBox
                      className='sticky-wrapper'
                      offsetTop={
                        sale_highlights.banner !== undefined ? -140 : 180
                      }
                      bottom={responsive?.xs && !responsive?.sm}
                    >
                      {sale_highlights.banner !== undefined && (
                        <PcModelSaleHighlights
                          sale_highlights={sale_highlights}
                        />
                      )}
                      <PcModelOverview
                        productType={productType}
                        sale_highlights={sale_highlights}
                      />
                    </StickyBox>
                  )}
                  {/* <div
                      className="sticky-wrapper"
                      // offsetTop={-1200}
                      // bottom={responsive?.xs && !responsive?.sm}
                    > */}
                  {/* <PcModelOverview productType={productType} /> */}
                  {/* </div> */}
                </div>
              </div>
            </div>

            <PcModelStepsNext productType={productType} hideMobile />
          </div>
        </PcConfiguratorProvider>
      </QueryParamProvider>

      <style jsx>{styles}</style>
      <style jsx>{global}</style>
    </>
  );
};

export default PcModel;
